import { useEffect, useState } from "react";

export function useCountdown(startSeconds: number) {
  const [remaining, setRemaining] = useState(startSeconds);

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? startSeconds : prev - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [startSeconds]);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  const pad = (n: number) => String(n).padStart(2, "0");

  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) };
}
